export default function PHP_xml_set_external_entity_ref_handler() {
  return (
    <div>
      <h1>PHP_xml_set_external_entity_ref_handler</h1>
    </div>
  );
}
